import i18next from 'i18next';

import { confirmDeletion } from '@vlabs/monokit/shared/ui/confirm-deletion';

interface ConfirmDeleteStreamsProps {
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
}

export function confirmDeleteStreams({
  onConfirm,
  onReject,
}: ConfirmDeleteStreamsProps): void {
  confirmDeletion({
    cancelLabel: i18next.t('features:deleteStream.confirmation.buttons.cancel'),
    confirmLabel: i18next.t('features:deleteStream.confirmation.buttons.delete'),
    onConfirm,
    onReject,
    subtitle: i18next.t('features:deleteStream.confirmation.subtitle'),
    title: i18next.t('features:deleteStream.confirmation.title'),
  });
}
